import { useInfiniteQuery } from "@tanstack/react-query"
import type { PropertyJournalResponse } from "@zplanem/responses"
import { apiFetch } from "../../lib/api-client"
import { queryKeys } from "../../lib/query-keys"

export function usePropertyJournal(
	propertyId: string | undefined,
	projectId?: string,
) {
	return useInfiniteQuery({
		queryKey: propertyId
			? queryKeys.propertyJournal(propertyId, projectId)
			: ["properties", "__nil__", "journal"],
		queryFn: ({ pageParam }) => {
			const params = new URLSearchParams()
			if (pageParam) params.set("cursor", pageParam)
			if (projectId) params.set("projectId", projectId)
			const qs = params.size > 0 ? `?${params.toString()}` : ""
			return apiFetch<PropertyJournalResponse>(
				`/api/common/properties/${propertyId}/journal${qs}`,
			)
		},
		getNextPageParam: (last) => last.nextCursor ?? undefined,
		initialPageParam: null as string | null,
		enabled: !!propertyId,
	})
}
